import React from "react";

export default function SearchIcon({ color = "#424242", ...restProps }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" {...restProps}>
      <g stroke={color} strokeWidth="2" fill="none">
        <circle cx="7" cy="7" r="6" />
        <line x1="12" y1="12" x2="15" y2="15" strokeLinecap="round" />
      </g>
    </svg>
  );
}
